export default "__VITE_ASSET__BoDbQLnh__"